import React from 'react';
import {Platform, Share, TouchableOpacity, View} from 'react-native';

import Text from '/component/base/Text';
import {EVENT_NAMES, SCREEN_NAMES} from '/enum/tealium.enum';
import {usePopover} from '/provider/PopoverProvider/createPopoverProvider';
import {Logger} from '/util/splunk/logger.util';
import {getTealiumUtilDefaultInstance} from '/util/tealium';
import {getBrowserInfo} from '/util/web/deviceDetection.util';

import ShareStreakPopover from './ShareStreakPopover';
import {styles} from './StreakCard.style';

const StreakCard = ({
  latestStreakData,
  coachId,
  lastPaidRank,
  highestAchievedRank,
  coachCurrentRank,
}: any) => {
  const {popoverShow} = usePopover();
  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.sharePlan,
  });
  const coachIdStr = coachId.toString();

  const handleShare = async () => {
    const shareMessage = `I'm on a ${latestStreakData} day streak for EDGE30!`;
    const shareTitle = 'Share my EDGE30 Streak';

    sendEvent({
      screenName: SCREEN_NAMES.edge30,
      lastPaidRank: lastPaidRank,
      coachHighestRank: highestAchievedRank,
      coachCurrentRank: coachCurrentRank,
      coachID: coachIdStr,
    });

    try {
      if (Platform.OS === 'web') {
        const browserInfo = getBrowserInfo();
        const isFirefox = browserInfo.name === 'Firefox';

        if (isFirefox) {
          popoverShow(ShareStreakPopover, {
            shareMessage,
            shareTitle,
          });
          return;
        }

        // For other browsers, try native sharing if available
        if (navigator.share) {
          try {
            await navigator.share({
              title: shareTitle,
              text: shareMessage,
            });
            return;
          } catch (shareError: any) {
            if (shareError?.name === 'AbortError') {
              return;
            }
          }
        }
      }

      // Mobile native share or fallback for web
      await Share.share({
        message: shareMessage,
        title: shareTitle,
      });
    } catch (error) {
      Logger.manualSplunkLog({
        loginType: 'Manual',
        message: `Share streak error with user : ${JSON.stringify(error)}`,
        severity: 'LOW',
      });
    }
  };

  return (
    <View style={styles.container}>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        style={styles.title}
        isBold
        accessible={true}
        accessibilityRole="header">
        EDGE30
      </Text>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        style={styles.subtitle}
        accessible={true}>
        Engage Duplicate Grow Elevate
      </Text>
      <View style={styles.buttonContainer}>
        <TouchableOpacity
          style={styles.streakButton}
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel={`${latestStreakData} day streak`}>
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.streakText}
            isBold
            accessible={true}>
            {latestStreakData} Day Streak!
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.shareButton}
          onPress={handleShare}
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel="Share streak">
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.shareText}
            isBold
            accessible={true}>
            Share Streak
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default StreakCard;
